class AreaCodeHolder {
    instance = null
    areaCode = '4510'
    level = 1
    static getInstance () {
        if (!this.instance) {
            this.instance = new AreaCodeHolder();
            return this.instance;
          } else {
            return this.instance;
          }
    }

    constructor() {
    }
  }
  export default AreaCodeHolder;
